/**
 *  TileBg2
 *
 *  Created by Legman on 13/03/2017.
 *
 */

import BaseTile from "./BaseTile";
import Common   from "./Common";

/**
 * @class
 */
export default class TileBg2 extends BaseTile {
    constructor() {
        const assets = Common.assets;

        super(assets.getTexture("tile_005"));

        this.view.anchor = new PIXI.Point();

        let light = this.createLight();
        light.x = Common.STAGE_WIDTH;
        light.y = Common.STAGE_HEIGHT * 0.5;
        light.scale.x = -1;
    }
}
